import { render } from "./FeatureDelete.vue?vue&type=template&id=23de2b59&ts=true"
import script from "./FeatureDelete.vue?vue&type=script&lang=ts"
export * from "./FeatureDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__